const aes_key = process.env.VUE_APP_AES_SECRET_KEY ?? "";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { AES, enc } from "crypto-js";

/**
 * Decrypts an AES-encrypted password. Returns the original string if decryption
 * fails (e.g. plain text or malformed data) so validation and display don't throw.
 */
export function decrypt_password(password: string): string {
  if (!password || typeof password !== "string") return "";
  try {
    const decrypted = AES.decrypt(password, aes_key).toString(enc.Utf8);
    return decrypted || password;
  } catch {
    return password;
  }
}
